import React from 'react';

/**
 * SAAGrid — global "chalkboard playbook" background layer.
 *
 * Applied to <html>/<body> via CSS variables so it sits behind every
 * route without competing with page-level stacking contexts. Uses a
 * scoped <style> tag that scopes body's background to the four-layer
 * pattern (base, grid, ember, vignette) all at once.
 *
 * This is the visual identity anchor. Do not remove per-page.
 */
const SAAGrid = () => {
  return (
    <style>{`
      html, body {
        background-color: #050508 !important;
        background-image:
          radial-gradient(ellipse 75% 55% at 50% 0%, rgba(255,94,0,0.28) 0%, rgba(255,94,0,0.09) 38%, transparent 72%),
          linear-gradient(rgba(255,94,0,0.16) 1px, transparent 1px),
          linear-gradient(90deg, rgba(255,94,0,0.16) 1px, transparent 1px);
        background-size: 100% 85vh, 48px 48px, 48px 48px;
        background-position: top center, top left, top left;
        background-repeat: no-repeat, repeat, repeat;
        background-attachment: fixed, fixed, fixed;
      }
      /* Bottom vignette painted onto #root so it scrolls with content */
      body::after {
        content: '';
        position: fixed;
        left: 0; right: 0; bottom: 0;
        height: 30vh;
        background: linear-gradient(180deg, transparent 0%, rgba(0,0,0,0.65) 100%);
        pointer-events: none;
        z-index: 0;
      }
    `}</style>
  );
};

export default SAAGrid;
